export enum SurveyorSurveyType {

  HEALTH_TEAM = 'Health Team',
  LIFE_SAFETY_TEAM = 'Life Safety Team',
  WALK_ALONG = 'Walk-Along',
  OBSERVER = 'Observer',
  VALIDATION = 'Validation'
}
